import { RestRequest, RestContext, ResponseFunction } from 'msw'
import {
  addToEntityListData,
  updateEntityListData,
  deleteEntityListData,
} from '../../modules/mockDataCommon'
import { requireAuthenticatedUser } from '../../decorators'
import { getSupplierResourceListData } from './mockData'
import type { ISupplierResource } from '~/types/supplier/models'

interface GetSupplierResourcesResponse {
  data: ISupplierResource[]
}

async function getSupplierResources(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  const responseBody: GetSupplierResourcesResponse = {
    data: await getSupplierResourceListData(),
  }
  return res(ctx.status(200), ctx.json(responseBody))
}

// post

const postSupplierResource = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return addToEntityListData(req, res, ctx, getSupplierResourceListData)
}

const patchSupplierResource = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return updateEntityListData(req, res, ctx, getSupplierResourceListData)
}

const deleteSupplierResource = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return deleteEntityListData(req, res, ctx, getSupplierResourceListData)
}

export const handlers = [
  {
    method: 'get',
    path: '/api/supplierresources',
    handler: getSupplierResources,
  },
  {
    method: 'post',
    path: '/api/supplierresources',
    handler: postSupplierResource,
  },
  {
    method: 'patch',
    path: '/api/supplierresources/:id',
    handler: patchSupplierResource,
  },
  {
    method: 'delete',
    path: '/api/supplierresources/:id',
    handler: deleteSupplierResource,
  },
].map((h) => ({ ...h, ...{ handler: requireAuthenticatedUser(h.handler) } }))
